import { render, staticRenderFns } from "./DraftPriceExtendPreview.vue?vue&type=template&id=151974ca&"
import script from "./DraftPriceExtendPreview.vue?vue&type=script&lang=js&"
export * from "./DraftPriceExtendPreview.vue?vue&type=script&lang=js&"
import style0 from "./DraftPriceExtendPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports